import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type CtsModuleUpdateSettings } from '../../../../api/types';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import CtsModuleUpdateForm from './CtsModuleUpdateForm';

type CtsModuleUpdateDrawerProps = {
    moduleId: string;
    initialValues: CtsModuleUpdateSettings;
    visible: boolean;
    onClose: () => void;
};

const CtsModuleUpdateDrawer = ({ moduleId, initialValues, visible, onClose }: CtsModuleUpdateDrawerProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('ctsModuleDetails:actions.cancel')}</Button>
                    <Button form="updateCtsModule" htmlType="submit" type="primary">
                        {t('ctsModuleDetails:actions.update')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('ctsModuleDetails:mainActionButtons.updateSpecs')}
            visible={visible}
            destroyOnClose
        >
            <CtsModuleUpdateForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default CtsModuleUpdateDrawer;

export const useCtsModuleUpdateDrawer = (
    moduleId: string,
    initialValues: CtsModuleUpdateDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <CtsModuleUpdateDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
